import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import MainMenu from '@/components/MainMenu.vue'
import TourGjz from '@/components/TourGjz.vue'
import TourCAWSmart from '@/components/TourCAWSmart.vue'
import MaintainInfo from '@/components/MaintainInfo.vue'
import VideoPlayer from '@/components/VideoPlayer.vue';
// import StationNews from '@/components/StationNews.vue'
import AboutUs from '@/components/AboutUs.vue'
import TourScene from '@/components/TourScene.vue';

const routes = [
  {
    path: '/',
    name: 'MainMenu',
    component: MainMenu
  },
  {
    path: '/tourscene',
    name: 'TourScene',
    component: () => import(/* webpackChunkName: "tourscene", webpackPrefetch: true */ '@/components/TourScene.vue')
  },
  {
    path: '/tourgjz',
    name: 'TourGjz',
    component: TourGjz
  },
  {
    path: '/tourcawsmart',
    name: 'TourCAWSmart',
    component: TourCAWSmart
  },
  {
    path: '/maintain-info',
    name: 'MaintainInfo',
    component: () => import(/* webpackChunkName: "maintain-info", webpackPrefetch: true */ '@/components/MaintainInfo.vue'),
    meta: {
      keepAlive: true //需要被缓存
    }
  },
  { path: '/video/:folder/:fileName', name: 'VideoPlayer', component: VideoPlayer, props: true },
  { path: '/video/:folder', name: 'VideoListByFolder', component: MaintainInfo, props: true },
  // {
  //   path: '/station-news',
  //   name: 'StationNews',
  //   component: StationNews
  // },
  {
    path: '/aboutus',
    name: 'AboutUs',
    component: () => import(/* webpackChunkName: "aboutus", webpackPrefetch: true */ '@/components/AboutUs.vue')
  }
]

// 平时用这个
// const router = createRouter({
//   history: createWebHistory(),
//   routes
//   // base: '/zdz_demo/'
// })

// 打包用这个
const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  base: '/zdz_demo/'
});

export default router